import React, { useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import useTransportService from '../../../app/services/hooks/useTransportService';
import useNavigationPage from '../../../hooks/useNavigationPage';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { TransportDataForm, defaultTransportDataForm } from '../../../app/models/Transport';
import { ServiceResponse } from '../../../app/services/shared/interfaces';

import TransportForm from './forms/TransportForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const TransportCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { navigationPage } = useNavigationPage();
    
    const { storeTransport, fetchingStoreTransport } = useTransportService();

    const [transport, setTransport] = useState<TransportDataForm>(defaultTransportDataForm);
    const [errorFields, setErrorFields] = useState<any>();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando transporte...');

        // Preparar los datos para enviar
        const dataToSend: TransportDataForm = {
            vehicle_id: transport.vehicle_id,
            dispatch_date: transport.dispatch_date || null,
            nodes: transport.nodes?.map(node => ({
                location_id: node.location_id || 0,
                sequence: node.sequence || 0
            })).filter(node => node.location_id && node.location_id > 0) || [],
            delivery_ids: transport.delivery_ids || []
        };

        storeTransport(dataToSend, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                toast.success(response.message, { autoClose: 2500 });
                
                // Navegar a edición con el ID creado
                navigationPage('/transports/' + response.data.transport_id + '/edit');
                
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <div className="transport-form-container" style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', maxHeight: '100%' }}>
            <div className="row" style={{ flexShrink: 0, overflow: 'visible' }}>
                <div className="col-12">
                    <TransportForm
                        transport={transport}
                        setTransport={setTransport}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            
            <hr style={{ flexShrink: 0, margin: '0.75rem 0 0.5rem 0' }} />
            
            <div className="row justify-content-end" style={{ flexShrink: 0, marginTop: 0, marginBottom: 0 }}>
                <div className="col-auto">
                    <ButtonCancelForm 
                        callbackCancel={cancel} 
                        locked={fetchingStoreTransport} 
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm 
                        callbackSave={store} 
                        locked={fetchingStoreTransport} 
                    />
                </div>
            </div>
        </div>
    );
};

export default TransportCreate;
